import React from 'react';
import logo11 from '../assets/branding/logo11.svg';

const CompanyBadge = ({
  label = 'Powered by',
  company = 'Redqubes Innovation pvt.ltd',
  logoAlt = 'RedQubes Logo',
  className = ''
}) => {
  return (
    <div
      className={`company-badge inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-red-700 via-red-600 to-red-500 px-4 py-2 shadow-md ring-1 ring-red-800/10 ${className}`}
    >
      <span className="text-sm font-medium text-white/90">
        {label}
      </span>
      <span className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-white/15 ring-1 ring-white/20">
        <img src={logo11} alt={logoAlt} className="w-4 h-4 object-contain" />
      </span>
      <span className="text-sm font-medium text-white">
        {company}
      </span>
    </div>
  );
};

export default CompanyBadge;

